<app-dialog-header [title]="'ENGAGE.HOME_SCREEN.BUTTONS.CHOOSE_AUDIENCES'" (onClick)="dialogRef.close(false)"></app-dialog-header>

<div class="p-24">
    <ng-container *ngIf="alreadySelectedAudiences.length">
        <h3 class="mb-12">{{ 'GENERAL.LABEL.SELECTED' | translate }}</h3>
        <mat-chip-set class="chip-list mb-24 wrap">
            <mat-chip class="chip" [removable]="removable" (removed)="removeFromList(item, i)" *ngFor="let item of alreadySelectedAudiences; let i = index">
                {{ item.valueToShow }}
                <mat-icon matChipRemove *ngIf="removable">cancel</mat-icon>
            </mat-chip>
        </mat-chip-set>
    </ng-container>

    <div class="p-16 bg-gray-100">
        <app-audience-filter
            #audienceList
            [useGrowFiltersStream]="true"
            [preSelectUnassigned]="isUnassignedAudienceSelected"
            (addedToList)="addToList($event)"
            [isSingleSelect]="false"
            [alreadySelectedAudiences]="alreadySelectedAudiences"
        ></app-audience-filter>
    </div>
</div>

<div class="pt-24 action-buttons" fxLayoutAlign="space-between center">
    <app-white-button [disabled]="alreadySelectedAudiences.length <= 1" [label]="'GENERAL.LABEL.CLEAR_FILTERS'" (onClick)="clearFilters()"></app-white-button>
    <div fxLayoutAlign="flex-end center">
        <app-white-button class="mr-8" [label]="'GENERAL.BUTTON.CANCEL'" (onClick)="cancel()"></app-white-button>
        <app-flat-button [label]="'GENERAL.BUTTON.SAVE'" (onClick)="save()"></app-flat-button>
    </div>
</div>
